import Underscore from 'underscore'

Underscore.isBlank = function(obj) {
  if (obj == null) return true

  if (Underscore.isArray(obj)) {
    return obj.length === 0
  } else if (Underscore.isString(obj)) {
    return obj.trim().length === 0
  } else if (Underscore.isObject(obj)) {
    return Underscore.keys(obj).length === 0
  } else {
    return Underscore.isNaN(obj) || Underscore.isUndefined(obj) || false
  }
}

Underscore.average = function(arr) {
  return Underscore.reduce(arr, function(memo, item) {
    return memo + item / arr.length
  }, 0)
}

// 移除第一个满足条件的元素
Underscore.rejectFirst = function(arr, func) {
  const _arr = arr.slice(0)
  const index = Underscore.findIndex(_arr, func)
  if (index === -1) return _arr
  _arr.splice(index, 1)
  return _arr
}

if (typeof window !== 'undefined') {
  window._ = Underscore
}

export default Underscore
